import { useState } from "react";
import { useFormContext } from "react-hook-form";

// Components
import CurrencyListMobile from "components/molecules/CurrencyListMobile";
import DialogWindow from "components/atoms/DialogWindow";

// Icons
import ArrowRight from "assets/icons/banger/arrow-right.svg?react";

// Types
import { WheelType } from "types/Wheel";

import "./styles.sass";

export type CurrencySelectVariationType = "primary" | "transparent";

type CurrencySelectMobileProps = {
  // eslint-disable-next-line react/no-unused-prop-types
  type?: WheelType;
  list: string[];
  onSelect: (currency: string) => void;
};

const CurrencySelectMobile = (props: CurrencySelectMobileProps) => {
  const { list, onSelect } = props;

  const [isOpen, setIsOpen] = useState(false);

  const { watch } = useFormContext();

  const currencyCode = watch("currencyCode");

  const handleSelect = (currency: string) => {
    if (!currencyCode) {
      setTimeout(() => {
        setIsOpen(false);
      }, 200);
    }
    onSelect(currency);
  };

  return (
    <>
      <button
        className="CurrencySelectMobile"
        type="button"
        onClick={() => setIsOpen(true)}
      >
        <span>{currencyCode}</span> <ArrowRight />
      </button>

      {isOpen ? (
        <DialogWindow
          classNamesProps="DialogWindow__zIndex"
          title="currency.select"
          isOpened={isOpen}
          onBackClose={() => setIsOpen(false)}
        >
          <CurrencyListMobile
            list={list}
            selected={currencyCode}
            onSelect={handleSelect}
          />
        </DialogWindow>
      ) : null}
    </>
  );
};

export default CurrencySelectMobile;
